import { Link } from 'react-router-dom'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../baseComponents/PermissionChecker'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import { OnSubmit } from '../../../../../forms/TwinForm/types'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import { CustomerTabKeys, useGetCustomerParsedLinkLogic } from '../functions'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ButtonSecondary } from '../../../../../baseComponents/Button'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'

interface CustomerDashboardSeeAllLinkProps {
    customerType: CustomerTypesInversedKeys
    customerTab: CustomerTabKeys
    text?: string
    className?: string
 }

export const CustomerDashboardSeeAllLink: React.FC<CustomerDashboardSeeAllLinkProps> = ({ customerType, customerTab, text, className }) => {
    const tab: CustomerTabKeys = customerTab
    const {t} = useTwinTranslation()
    const { parsedLink } = useGetCustomerParsedLinkLogic({ customerType, tab })
    let myText = text || t('seeAll', 'Ver todos')
    
    return (
        <Link to={parsedLink} className={'mt-3 text-green-21 cursor-pointer ' + (className || '')}>
            {myText}
        </Link>
    )
}

interface CustomerDashboardSeeAllButtonProps {
    customerType: CustomerTypesInversedKeys
    customerTab: CustomerTabKeys
    text?: string
}

export const CustomerDashboardSeeAllButton: React.FC<CustomerDashboardSeeAllButtonProps> = ({ customerType, customerTab, text }) => {
    const tab: CustomerTabKeys = customerTab
    const { parsedLink } = useGetCustomerParsedLinkLogic({ customerType, tab })

    return (
        <Link to={parsedLink} className='mt-3 text-green-21 cursor-pointer'>
            <ButtonSecondary className='w-full max-w-300 m-auto'>{text}</ButtonSecondary>
        </Link>
    )
}

interface CustomerDashboardAddButtonProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    text: string
    CreateModalComponent: React.FC<ModalEditComponentProps>
    extraModalData?: TwinDictionary
}

export const CustomerDashboardAddButton: React.FC<CustomerDashboardAddButtonProps> = ({ onSubmit, userPermissions, text, CreateModalComponent, extraModalData }) => {
    const { setOpenModal, openModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='create' userPermissions={userPermissions}>
            <div className='flex items-center text-green-21 cursor-pointer' onClick={() => setOpenModal({ type: 'create', allRowData: {} })}>
                <TwinIcon icon={faPlus} className='mr-4 regular12'/>
                {text}
            </div>
            {openModal?.type === 'create' ? <CreateModalComponent {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} basicData={extraModalData} /> : null}
        </PermissionChecker>
    )
}